export default {
  state: {
    chatText: {}
  },
  getter: {
    consoleChatText: state => {
      console.log(state.chatText, 'state.chatText')
    }
  },
  mutations: {
    setChatText: (state, val) => {
      state.chatText = val
    }
  },
  actions: {
    setChatText: (context, val) => {
      context.commit('setChatText', val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/chatStore/chat.js